<template lang="pug">
  .component-selectize-packet
    //pre {{items}}
    loading-spinner(v-if = "loading")
    selectize(v-if="options", :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved",  placeholder="Packet", :allowEmptyOption="allowEmptyOption", :selectedValue="selectedValue" :disabled="disabled")
</template>

<script>
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import BaseSelectize from './BaseSelectize'
  import Selectize from '../../../Selectize'
  import LoadingSpinner from '../../../LoadingSpinner'

  export default {
    name: 'SelectizePacket',
    extends: BaseSelectize,
    components: {Selectize, LoadingSpinner},
    data() {
      return {
        loading: true,
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.packets.list.all(1,-1, (data) => {
        this.options = Object.entries(data)
        this.loading = false
      })
    },
    methods: {
      optionTemplate(item, escape) {
        if (item.id) {
          return `<div><div><small>P${item.id}</small></div><div>${item.name}</div></div>`
        }
        return `<div><div>Select packet</div></div>`
      },
      renderTemplate(item, escape) {
        if (item.id) {
          return `<div>P${item.id} ${item.name}</div>`
        }
        return `<div><div>Select packet</div></div>`
      },
      optionsLoader() {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizePacket.vue?9f1e57f0